<script setup lang="ts">
defineProps<{
  title: string
  description: string
}>()
</script>

<template>
  <div class="instruction-card">
    <div class="instruction-icon">
      <slot name="icon" />
    </div>
    <h3>{{ title }}</h3>
    <p>{{ description }}</p>
  </div>
</template>

<style scoped>
.instruction-card {
  text-align: center;
  padding: 1.5rem 1rem;
}

@media (max-width: 480px) {
  .instruction-card {
    padding: 1rem 0.5rem;
  }
}

.instruction-icon {
  color: var(--icon-accent);
  margin-bottom: 1rem;
  display: flex;
  justify-content: center;
}

.instruction-card h3 {
  font-size: 1.125rem;
  font-weight: 600;
  margin-bottom: 0.75rem;
  color: var(--text-primary);
}

.instruction-card p {
  color: var(--text-secondary);
  line-height: 1.6;
  text-align: center;
}
</style>
